import type { Stage, TaskDetail } from "../api/types";

export interface SkipChoice {
  /** Label for the default: the next gate in this stage, or the next stage. */
  continueLabel: string;
  /** Later stages a human may jump to (never Done; mirrors the server rule). */
  targets: Stage[];
}

/** What "approve"/"submit" can lead to from the task's current position. */
export function skipChoice(task: TaskDetail): SkipChoice {
  const idx = task.stages.findIndex((s) => s.key === task.stage_key);
  const stage = task.stages[idx];
  const gateIdx = task.gate_index ?? -1;
  const nextGate = stage?.gates[gateIdx + 1];
  const nextStage = stage?.next ? task.stages.find((s) => s.key === stage.next) : task.stages[idx + 1];
  const continueLabel = nextGate
    ? `Next: ${nextGate.name || "next gate"}`
    : nextStage
      ? `${nextStage.name} (next)`
      : "Next step";
  // The natural next stage is only a "skip" when it would also skip this stage's remaining gates.
  const targets = task.stages.filter(
    (s, i) => i > idx && s.kind !== "done" && (nextGate !== undefined || s.key !== nextStage?.key),
  );
  return { continueLabel, targets };
}
